import List from './List'

export default class EpisodeList extends List {
  reset() {
    if (this._mainTransition) this._mainTransition.updateTargetValue(0)
    super._reset()
    this._fetchingMore = false
    if (this.wrapper) {
      this.wrapper.patch({
        y: 0,
        children: [],
        boundsMargin: [0, 350, 0, 350],
      })
    }
  }

  set scrollOffset(num) {
    this._scrollOffset = num
  }

  get scrollOffset() {
    return this._scrollOffset || 245
  }

  _init() {
    this._autoResize = false
    this._fetchingMore = false

    const isVertical = this._orientation === List.ORIENTATION.vertical

    this._mainTransition = this.wrapper.transition(isVertical ? 'y' : 'x')
  }

  set availableItems(nr) {
    this._availableItems = nr
  }

  _indexChanged(obj) {
    super._indexChanged(obj)

    const { previousIndex, newIndex, dataLength } = obj

    if (previousIndex === newIndex) {
      return
    }

    const current = this.currentItem

    const isVertical = this._orientation === List.ORIENTATION.vertical
    const main = isVertical ? 'y' : 'x'
    const mainDim = isVertical ? 'h' : 'w'
    const scrollOffset = this.scrollOffset
    const controlPoint = this._mainTransition.targetValue
    const boundary = this[mainDim]
    const boundaryStart = scrollOffset - controlPoint

    let m = controlPoint

    if (previousIndex > newIndex) {
      if (newIndex > 0 && current[main] < controlPoint * -1 + scrollOffset) {
        m = scrollOffset - current[main]
      } else if (current[main] < boundaryStart) {
        m = 0
      }
    } else {
      if (
        newIndex < dataLength - 1 &&
        current[main] + current[mainDim] > controlPoint * -1 + (boundary - scrollOffset)
      ) {
        m = boundary - scrollOffset - (current[main] + current[mainDim])
      } else if (newIndex === dataLength - 1 && current[main] + current[mainDim] >= boundary) {
        m = boundary - (current[main] + current[mainDim])
      }
    }

    if (this._mainTransition.isRunning()) {
      this._mainTransition.reset(m, 0.12)
    } else {
      this._mainTransition.start(m)
    }

    this._reposition()

    // See if (need to add more episodes
    //
    if (this._fetchingMore === false && dataLength < this._availableItems) {
      if (dataLength < newIndex + 150) {
        this._fetchingMore = true

        this.signal('requestMoreItems', { offset: dataLength }).then(items => {
          this.addItems(items)

          this._fetchingMore = false
        })
      }
    }

    this.signal('indexChanged', obj)
  }

  _getItemSize(item) {
    const margin = item.margin || item.margin || this.spacing

    return { sizes: item.sizes, margin }
  }

  _reposition() {
    if (this.wrapper.children.length === 0) {
      return
    }

    const wrapper = this.wrapper

    let position = 0

    wrapper.children.forEach((item, idx) => {
      const newPos = position
      const itemSize = this._getItemSize(item)
      const margin = itemSize.margin

      let h

      if (idx === this._index) {
        h = itemSize.sizes.h2
      } else {
        h = itemSize.sizes.h1
      }

      position += h + margin

      item.patch({
        assignedY: newPos,
        assignedX: 0,
        smooth: {
          y: [newPos, { duration: 0.3, timingFunction: 'ease-in' }],
          x: [0, { duration: 0.3, timingFunction: 'ease-in' }],
        },
      })
    })
  }

  unfocusList() {
    if (this.wrapper.children.length === 0) {
      return
    }

    const wrapper = this.wrapper

    let position = 0

    wrapper.children.forEach(item => {
      const newPos = position
      const itemSize = this._getItemSize(item)

      position += itemSize.sizes.h1 + itemSize.margin

      item.patch({
        assignedY: newPos,
        assignedX: 0,
        smooth: {
          y: [newPos, { duration: 0.2, timingFunction: 'ease-in' }],
          x: [0, { duration: 0.2, timingFunction: 'ease-in' }],
        },
      })
    })
  }

  episodeItem(index) {
    if (index === -1) {
      return null
    }

    return this.tag('Wrapper').children[index]
  }

  get episodeId() {
    if (!(this.currentItem && this.currentItem.item && this.currentItem.item.id)) {
      return '0'
    }

    return this.currentItem.item.id.toString()
  }
}
